export const changeGroupAdminNameToOrgAdmin = (raw: string): string => {
  return raw.replace(/Group Admin/g, 'Org Admin');
};

export const changeGroupNameToOrganization = (raw: string): string => {
  return raw.replace(/Group/g, 'Organization');
};
